import React from "react";
import "./Footer.css";
import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-column">
          <h3>Resort Map</h3>

<iframe  title="Sangam Resort & Banquet" 
src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3623.8120717685842!2d84.41271757542073!3d24.733331278012542!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x398cfd0077ce266f%3A0xbb490411d1dbdd87!2sSangam%20Resort%20%26%20Banquet%20Hall!5e0!3m2!1sen!2sin!4v1752599913783!5m2!1sen!2sin"
   allowfullscreen=""
   width="600"
            height="450"
    loading="lazy" 
    referrerpolicy="no-referrer-when-downgrade"
    ></iframe>

        </div>


        <div className="footer-column">
          <h3>Quick Links</h3>
          <ul>
      
            <li ><Link to='/' className="link">Home</Link></li>
            <li><Link to='/about' className="link">About Us</Link></li>

            <li><Link to='/events' className="link" >Events</Link></li>
            <li><Link to='/contact' className="link">Contact Us</Link></li>
            <li>  <Link to='/gallery' className="link">Gallery</Link></li>
          </ul>
        </div>


        <div className="footer-column">
          <h3>Contact Us</h3>

          <p>
            <strong>Resorts Address:</strong><br />
            📍 NH-2 , Near Ashok Leyland,Ajrakwe Hasauli,Aurangabaad,Bihar 824101,India
          </p>
          <p>📞 +91 8340539463</p>
          <p>✉️ sangamluxurious@gmail.com</p>

          <div className="social-icons">
            <a href="#"><i className="fab fa-facebook-f" /></a>
            <a href="#"><i className="fab fa-x-twitter" /></a>
            <a href="#"><i className="fab fa-linkedin-in" /></a>
            <a href="#"><i className="fab fa-instagram" /></a>
            <a href="#"><i className="fab fa-youtube" /></a>
          </div>
        </div>
      </div>

      <div className="footer-bottom">
        <p>
          © A Project by <span>Sangam Resort & Banquet</span> All Rights Reserved.
        </p>
      </div>
    </footer>
  );
};

export default Footer;
